export const DEFAULTVALUES = {
    home_queesbitcar: [
        {
            id: 'Leasing',
            title: '¿Qué es el Leasing?',
            content: `El leasing es un modelo de renta que te permite <b>estrenar un auto nuevo a cambio del pago de mensualidades fijas durante un plazo determinado</b> disfrutando de diversas ventajas:`,
            advantages: [
                {
                    img: './assets/img/v3/leasing-rent2buy-icono1.svg',
                    description: 'Pago inicial bajo',
                },
                {
                    img: './assets/img/v3/leasing-rent2buy-icono2.svg',
                    description: ' Administración de mantenimiento',
                },
                {
                    img: './assets/img/v3/leasing-rent2buy-icono3.svg',
                    description: 'Seguro de auto, vida y desempleo incluido',
                },
                {
                    img: './assets/img/v3/leasing-rent2buy-icono4.svg',
                    description: 'Te olvidas de la venta del vehículo',
                }
            ]
        },
        {
            id: 'Rent2Buy',
            title: '¿Qué es Rent2Buy?',
            content: `El Rent2Buy te permite <b>rentar un vehículo de 12 hasta 60 meses pero con la opción a comprarlo</b> por un precio menor al de mercado al término del contrato, disfrutando de las siguientes ventajas:`,
            advantages: [
                {
                    img: './assets/img/v3/leasing-rent2buy-icono5.svg',
                    description: 'Tú determinas cuál será el valor de compra'
                },
                {
                    img: './assets/img/v3/leasing-rent2buy-icono1.svg',
                    description: 'Pago inicial bajo',
                },
                {
                    img: './assets/img/v3/leasing-rent2buy-icono2.svg',
                    description: 'Administración de mantenimiento',
                },
                {
                    img: './assets/img/v3/leasing-rent2buy-icono3.svg',
                    description: 'Seguro de auto, vida y desempleo incluido',
                }
            ]
        },
        {
            id: 'Crédito',
            title: '¿Qué es el crédito BitCar?',
            content: `Este tipo de crédito te permite <b>adquirir el auto de tus sueños sin necesidad de pagar el monto total al inicio de la compra.</b> En su lugar, <b>podrás pagar la totalidad del auto en mensualidades</b> durante el período que elijas.`,
            advantages: [
                {
                    img: './assets/img/v3/leasing-plan-credito-icono1.svg',
                    description: 'Tu eres dueño del vehículo'
                },
                {
                    img: './assets/img/v3/leasing-plan-credito-icono2.svg',
                    description: 'Seguro de auto, vida y desempleo incluido',
                },
                {
                    img: './assets/img/v3/leasing-plan-credito-icono3.svg',
                    description: 'Rastreo/ GPS y auto sustituto',
                },
                {
                    img: './assets/img/v3/leasing-plan-credito-icono4.svg',
                    description: 'Plazos desde 12 hasta 60 meses',
                }
            ]
        }
    ],
    home_leaseProcess: {
        defaultTitle: '¿Cuáles son los pasos?',
        defaultSubtitle: '¡Sigue estos sencillos pasos!',
        cards: [
            {
                title: '1. Busca y configura',
                subtitle: 'Encuentra el auto que mas te agrade y configura tu plan.',
                srcImg: './assets/img/lease1.jpeg',
            },
            {
                title: 'Verifica y aprueba',
                subtitle: 'Carga tus documentos y valida la información.',
                srcImg: './assets/img/lease2.jpeg',
            },
            {
                title: '3. Firma tu contrato',
                subtitle: 'Firma el contrato y realiza el pago inicial para asegurar tu auto.',
                srcImg: './assets/img/lease3.jpeg',
            },
            {
                title: '4. Agenda y recibe tu auto',
                subtitle: '¡Recibe las llaves de tu próximo auto!',
                srcImg: './assets/img/lease4.jpeg',
            },
        ]
    },
    faqs: {
        "id": 1,
        "published_at": "2022-02-14T06:13:46.000Z",
        "created_at": "2022-02-14T06:09:51.000Z",
        "updated_at": "2022-02-14T06:13:46.000Z",
        "header": {
            "id": 9,
            "title": "¿Tienes alguna duda?",
            "subtitle": "Preguntas frecuentes"
        },
        "preguntas_respuestas": [
            {
                "id": 4,
                "question": "¿Puedo arrendar un seminuevo?",
                "answer": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. ",
                "link": "#answer1",
                "status": true,
                "quick_answer": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
            },
            {
                "id": 5,
                "question": "¿Puedo facturar mi pago inicial?",
                "answer": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. ",
                "link": "#answer2",
                "status": true,
                "quick_answer": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
            },
            {
                "id": 6,
                "question": "¿El pago inicial es reembolsable?",
                "answer": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. ",
                "link": "#answer3",
                "status": true,
                "quick_answer": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
            },
            {
                "id": 4,
                "question": "¿Puedo arrendar un seminuevo?",
                "answer": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. ",
                "link": "#answer1",
                "status": true,
                "quick_answer": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
            },
            {
                "id": 5,
                "question": "¿Puedo facturar mi pago inicial?",
                "answer": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. ",
                "link": "#answer2",
                "status": true,
                "quick_answer": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
            },
            {
                "id": 6,
                "question": "¿El pago inicial es reembolsable?",
                "answer": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. ",
                "link": "#answer3",
                "status": true,
                "quick_answer": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
            }
        ]
    },
    home_requirements: [
        {
            id: 'Asalariado',
            title: 'Documentos:',
            requirements: [
                {
                    doc: `Comprobante de ingresos`,
                },
                {
                    doc: `Comprobante de domicilio`,
                },
                {
                    doc: `Identificación oficial vigente`,
                },
                {
                    doc: `Constancia de situación fiscal`,
                }

            ]
        },
        {
            id: 'Combinado',
            title: 'Documentos:',
            extratitle: 'Para comprobar ingresos adicionales, necesitas:',
            requirements: [
                {
                    doc: `Checklist asalariado`,
                },
                {
                    doc: `Otros documentos`,
                },
            ],
            extras: [
                {
                    doc: `4 meses de estados de cuenta con los ingresos adicionales`,
                },
                {
                    doc: `Última declaración de impuestos con su acuse`,
                }
            ]
        },
        {
            id: 'Profesionista independiente',
            title: 'Monto del arrendamiento (con IVA) menor o igual a MXN 750 mil:',
            title2: 'Monto de arrendamiento (con IVA) mayor a MXN 750 mil',
            requirements: [
                {
                    doc: `Última declaración de impuestos anual (con acuse de recibo)*`,
                },
                {
                    doc: `Estados de cuenta (4 últimos meses completos y consecutivos)`,
                },
                {
                    doc: `Identificación oficial vigente`,
                },
                {
                    doc: `Comprobante de domicilio`,
                }
            ],
            requirements2: [
                {
                    doc: `Últimas dos declaraciones de impuestos anual (con acuse de recibo)*`,
                },
                {
                    doc: `Estados de cuenta (6 últimos meses completos y consecutivos)`,
                },
                {
                    doc: `Identificación oficial vigente`,
                },
                {
                    doc: `Comprobante de domicilio`,
                }
            ],
            extras: [],
            note: `*Si tienes dudas, confirmar estos datos con tu asesor BitCar`,

        },
        {
            id: 'Ex Patriado',
            title: 'Ex Patriado',
            requirements: [
                {
                    doc: `Identificación oficial mexicana`,
                },
                {
                    doc: `Comprobante de domicilio vigente (no mayor a 3 meses)`,
                },
                {
                    doc: `Comprobante de ingresos`,
                },
                {
                    doc: `Constancia de situación fiscal`,
                },
                {
                    doc: `Carta laboral de la empresa firmada por el área de RH`,
                }
            ]
        }
    ],
    home_conocemas: [
        {
            id: 'Leasing',
            class: 'bitcar-head',
            classli: 'li-orange',
            plans: [
                {
                    plan: 'La opción con la mensualidad más baja'
                },
                {
                    plan: 'Arrendamiento puro de 24 a 48 meses'
                },
                {
                    plan: 'La renta incluye seguro automotriz, servicios de localización y recuperación'
                },
                {
                    plan: 'Acompañamiento legal en caso de siniestro'
                },
                {
                    plan: 'Generación de citas de mantenimiento'
                },
                {
                    plan: 'El auto se entrega con placas, pago de derechos o tenencia y verificación'
                }
            ]
        },
        {
            id: 'Rent2Buy',
            class: 'black-head',
            classli: 'li-black',
            plans: [
                {
                    plan: 'Arrendamiento orientado a compra al final del plazo'
                },
                {
                    plan: 'Plazos de 12 hasta 60 meses'
                },
                {
                    plan: 'Incluye seguro automotriz, servicio de localización y recuperación'
                },
                {
                    plan: 'Acompañamiento legal en caso de siniestro'
                },
                {
                    plan: 'Generación de citas de mantenimiento'
                },
                {
                    plan: 'El auto se entrega con placas'
                },
                {
                    plan: 'Es la opción si estás seguro de comprar al final el auto'
                }
            ]
        },
        {
            id: 'Crédito BitCar',
            class: 'bitcar-head',
            classli: 'li-orange',
            plans: [
                {
                    plan: 'Eres el propietario del auto desde el inicio del contrato'
                },
                {
                    plan: 'Enganche del 20% al 35%'
                },
                {
                    plan: 'Plazos de 12 hasta 60 meses'
                },
                {
                    plan: 'Incluye seguro automotriz, servicio de localización y recuperación'
                },
                {
                    plan: 'Acompañamiento legal en caso de siniestro'
                },
                {
                    plan: 'Generación de citas de mantenimiento'
                }
            ]
        }
    ]

}